import { cn } from "@u/cn";
import { SectionHeader } from "./SectionHeader";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  highlight?: string;
  description: string;
  right?: React.ReactNode;
  className?: string;
  /** Entrance fade del header (pass-through a SectionHeader). Opt-in. */
  reveal?: boolean;
}

export function PageHeader({
  eyebrow,
  title,
  highlight,
  description,
  right,
  className,
  reveal = false,
}: PageHeaderProps) {
  return (
    <section
      className={cn(
        "w-full border-b border-border/20 py-12 md:py-16 bg-muted/5",
        className,
      )}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <SectionHeader
            as="h1"
            eyebrow={eyebrow}
            title={title}
            highlight={highlight}
            description={description}
            reveal={reveal}
          />
          {right}
        </div>
      </div>
    </section>
  );
}
